module.exports = __webpack_public_path__ + "assets/images/3-23.39ae3df3.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@int/signature/assets/images/preview/3-23.png
// module id = 2103
// module chunks = 0